import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Course from '../Course/Course';

const Courses = () => {
    const [courses, setCourses] = useState([]);
    useEffect(() => {
        fetch('./data.json')
            .then(res => res.json())
            .then(data => setCourses(data));

    }, []);
    return (
        <div>
            <Row xs={1} md={4} className="g-4 m-5 ">
                {
                    courses.map(data => <Course
                        key={data.id}
                        data={data}
                    >
                    </Course>)
                }


            </Row>
        </div>
    );
};

export default Courses;